export default "__VITE_ASSET__Cu$L2zv3__"